<template>
	<div class="home_page">
		<!-- 顶部 -->
		<div class="mod_header">
			<div class="layout_header">
				<a :href="api.SK_AI_INDEX_URL" class="mod_header_logo">
					<img src="../static/images/logo.jpg">
				</a>
				<div class="mod_header_nav">
					<ul class="header_nav_box">
						<li v-for="(item,i) in navObj" :class="{'item_bar':item.itemBar}" class="nav_li" @mouseover="navMouseover($event)" @mouseout="navMouseout($event,i)" @click="toPage(item,i)">
							<h2 class="nav_content">
								<span>{{item.name}}</span>
								<i class="el-icon-arrow-down" v-show="item.arrow"></i>
							</h2>
							<div class="case_menu" v-if="item.menuObj">  
								<router-link :to="obj.url" v-for="obj in item.menuObj" class="menu_link">
									{{obj.name}}
								</router-link>
							</div>
							<div class="case_experience" v-if="item.menuList">
								<ul v-for="list in item.menuList" class="menu_experience">
									<div class="menu_experience_list">
										<a :href="list.url" class="experience_link">{{list.name}}</a>
										<div class="experience_links_box">
											<a :href="data.url" v-for="data in list.val" class="small_link">{{data.name}}</a>
										</div>
									</div>
								</ul>
							</div>
						</li>
					</ul>
					<i class="header_nav_slider" :class="{'hidden':isHidden}" ref="sliderBar"></i>
				</div>
				<div class="mod_header_user">
					<a :href="api.SK_AI_INDEX_URL+'/console/dashboard'" target="_blank" class="console_link">控制台</a><!-- 未登录用 -->
					<!-- <a href=""  target="_blank" class="console_link">控制台</a>  --><!-- 已登录用 -->
				</div>
			</div>
		</div>
		<!-- 主体 -->
		<div class="mod_content">
			<router-view/>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				navObj:[//导航条数据
					{
						name:"首页",
						arrow:false,
						menu:false,
						itemBar:true,
						url:this.api.SK_AI_INDEX_URL,
					},
					{
						name:"体验中心",
						arrow:false,
						menu:true,
						itemBar:false,
						url:this.api.SK_AI_INDEX_URL+"/Experience/experience-face",
						menuList:[
							{
								name:'人脸识别',
								url:this.api.SK_AI_INDEX_URL+"/Experience/experience-face",
								val:[
									{
										name:'人脸检测',
										url:this.api.SK_AI_INDEX_URL+"/Experience/face-detect"
									},
									{
										name:'五官定位',
										url:this.api.SK_AI_INDEX_URL+"/Experience/face-alignment"
									},
									{
										name:'人脸对比',
										url:this.api.SK_AI_INDEX_URL+"/Experience/face-compare"
									},
									{
										name:'人脸搜索',
										url:this.api.SK_AI_INDEX_URL+"/Experience/face-search"
									},
								]
							},
							{
								name:'物体识别',
								url:this.api.SK_AI_INDEX_URL+"/Experience/experience-object",
								val:[
									{
										name:'常见物体识别',
										url:this.api.SK_AI_INDEX_URL+"/Experience/recognition?type=objects",
									},
									{
										name:'水果识别',
										url:this.api.SK_AI_INDEX_URL+"/Experience/recognition?type=fruits",
									},
									{
										name:'植物识别',
										url:this.api.SK_AI_INDEX_URL+"/Experience/recognition?type=plant",
									},
									{
										name:'酒品识别',
										url:this.api.SK_AI_INDEX_URL+"/Experience/recognition?type=plant",
									},
									{
										name:'饮料识别',
										url:this.api.SK_AI_INDEX_URL+"/Experience/recognition?type=beverage",
									},
								]
							}
						],
						
					},
					{
						name:"文档中心",
						arrow:false,
						menu:false,
						itemBar:false,
						url:'/dochomepage'
						//url:this.api.SK_AI_INDEX_URL+'/dochomepage'
						// menuObj:[
						// 	{name:'接入指南',url:'/documentIndex'},
						// 	{name:'API文档',url:'/documentIndex'},
						// ]
					},
					{
						name:"SDK下载",
						arrow:false,
						menu:false,
						itemBar:false,
						url:this.api.SK_AI_INDEX_URL+'/Experience/sdk',
					},
					{
						name:"深度定制",
						arrow:false,
						menu:false,
						itemBar:false,
						url:this.api.SK_AI_INDEX_URL+"/Experience/experience-customization",
					},
				],
				itemBarNumbder:0,//激活的导航项
				isHidden:true,//浮动横条
			}
		},
		watch:{

		},
		methods:{
			toPage(item,i){//点击页面跳转
				// console.log(item,i)
				if (i!=this.itemBarNumbder){//判定导航字体激活项
					this.navObj[i].itemBar=true;
					this.navObj[this.itemBarNumbder].itemBar=false;
					this.itemBarNumbder = i;
				}
				if (i==2){
					this.$router.push({path:item.url})
				}else {
					if (item.url) {window.location.href = item.url}
					
				}

			},
			navMouseover(e){//鼠标移入导航条
				//console.log(e,e.target.className,'移入')
				setTimeout(()=>{
					this.isHidden=false;
				},0)
				
				if (e.target.nodeName=='LI') {
					// console.log(e.target.offsetLeft )
					setTimeout(()=>{
						this.$refs.sliderBar.style.transform = 'translateX('+e.target.offsetLeft+'px)'
						this.$refs.sliderBar.style.width = e.target.clientWidth+"px"
					},10)
					
				}
				if (e.target.nodeName=='H2') {
					let el = e.target.parentNode; 
					//console.log(el)
				}
				if (e.target.nodeName=='SPAN'||e.target.nodeName=='I') {
					let el = e.target.parentNode.parentNode;
					setTimeout(()=>{
						this.$refs.sliderBar.style.transform = 'translateX('+el.offsetLeft+'px)'	
						this.$refs.sliderBar.style.width = el.clientWidth+"px"
					},10)
					
					//console.log(el.clientWidth,'span,i')
				}
				
			},
			navMouseout(e,i){//鼠标移除导航条
				console.log(1)
				this.isHidden=true;
				// if (e.target.nodeName=="LI") {
				// 	this.$refs.sliderBar.style.width = 0+"px"
				// }
				
			}
		},
		mounted(){
			if (this.$route.meta){
				for(let i=0;i<this.navObj.length;i++){
					this.navObj[i].itemBar = false
				}
				if (this.$route.meta.type=="document"){
					this.navObj[2].itemBar = true
				}
			}
			
		}
	}	
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.home_page{//子页面
		height: 100%;
		width: 100%;
		.mod_header{//顶部
			width: 100%;
		    font-size: 14px;
		    position: fixed;
		    top: 0;
		    left: 0;
		    box-sizing: border-box;
		    color: #fff;
		    z-index: 100;
		    height: 78px;
		    //transition: background .3s ease;
		    background: #1d1d1d;
		    .layout_header{//顶部内框
		    	// min-width: 1200px;
		    	// width: auto;
		    	width: 1200px;
		    	position: relative;
		    	margin:0 auto;
		    	.mod_header_logo{//logog
			    	float: left;
				    height: 78px;
				    //margin-left: 10px;
				    margin-right:35px;
				    img{
				    	display: block;
				    	height: 78px;
				    }
			    }	
			    .mod_header_nav{//导航框
			    	position: relative;
    				float: left;
    				padding-left:80px;
    				.header_nav_box{
    					.nav_li{//导航列表项
    						position: relative;
						    float: left;
						    line-height: 1;
    						text-align: center;
						    padding:0 12px;
						    margin: 0 25px 0 25px;
						    cursor: pointer;
						    line-height: 78px;
						    .nav_content{//导航列表内容
						    	padding: 0;
    							position: relative;
						    	text-decoration: none;
							    cursor: pointer;
							    outline: none;
							    color: inherit;
							    font-size: 14px;
							    font-weight: 400;
							    .el-icon-arrow-down{//箭头
							    	transition: transform .3s ease;
							    	transform: rotate(0deg);
							    }
						    }
						    .case_menu{//文档中心下拉框
						    	color: #fff;
							    box-sizing: border-box;
							    padding: 14px 0;
							    background-color: #1D1D1D;
							    position: absolute;
							    width: 94px;
							    top: 78px;
							    left: 0;
							    text-align: center;
							    transition: transform .3s ease-out;
							    -ms-transform: scaleY(0);
							    transform: scaleY(0);
							    -ms-transform-origin: center top;
							    transform-origin: center top;
							    z-index: 100;
							    .menu_link{//下拉按钮
							    	display: block;
    								padding: 10px 0;
							    }
							    .menu_link:hover{
							    	color:@primary-color;
							    	background: #42464C;
							    }
						    }
						    .case_experience{//体验中心下拉
						    	color: #fff;
							    box-sizing: border-box;
							    padding: 14px 0;
							    background-color: #1D1D1D;
							    position: absolute;
							    top: 78px;
							    left: 0;
							    text-align: center;
							    transition: transform .3s ease-out;
							    -ms-transform: scaleY(0);
							    transform: scaleY(0);
							    -ms-transform-origin: center top;
							    transform-origin: center top;
							    padding:5px 10px;
							    z-index: 100;
						    	.menu_experience{
							    	.menu_experience_list{
							    		margin:0;
							    		padding:0;
							    		width: 265px;
							    		line-height: 25px;
							    		.experience_link{
							    			color:#737373;
							    			text-align: left;
							    			float: left;
							    			padding:0 5px;
							    		}
							    		.experience_links_box{
							    			clear: both;
							    			overflow: hidden;
							    			.small_link{
							    				float: left;
							    				padding:0 5px;
							    			}
							    			.small_link:hover{
							    				color:@primary-color;
							    			}
							    		}
							    	}
							    }
						    }
    					}
    					.nav_li:hover{
    						.nav_content{
							    .el-icon-arrow-down{
							    	transform: rotate(180deg);
							    }
							   	//color:@primary-color;
						    }
						    .case_menu{
							    -ms-transform: scaleY(1);
							    transform: scaleY(1);
							}
							.case_experience{
								-ms-transform: scaleY(1);
							    transform: scaleY(1);
							}
    					}
    					.nav_li+.nav_li{
    						// margin-left:0;
    					}
    					.item_bar{
    						color:@primary-color;
    					}
    				}
    				.header_nav_slider{
    					position: absolute;
					    bottom: 0;
					    left: 0;
					    pointer-events: none;
					    width: auto;
					    height: 4px;
					    background-color: @primary-color;
					    transition: transform .3s ease-out,width .3s ease-out;//
					    width: 48px;
						transform:translateX(50px);
    				}
    				.hidden{
    					display: none !important;
    				}
			    }
			    .mod_header_user{//用户控制台
			    	line-height: 25px;
				    position: absolute;
				    top: 27.5px;
				    right: 0;
				    font-size: 0;
				    .console_link{
				    	background-color: #fff;
					    color: #0052d9;
					    padding: 8px 18px;
					    border-radius: 3px;
					    line-height: 1;
					    display: inline-block;
					    transition: all .3s ease;
					    vertical-align: middle;
					    font-size: 14px;
					    margin-right: 20px;
					    margin-top: -2.5px;
				    }
				    .console_link:hover{
				    	background: @primary-color;
				    	color:#fff;
				    }
			    }
		    }
		    .layout_header:after{
		    	clear: both;
		    	content:' ';
			    display: table;
		    }
		}
		.mod_header:hover{
		    //background-color:#1b1b1b;
		}
		.mod_content{
			position:relative;
			background: #fff;
			height: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/homepage.vue